// @ts-nocheck
import { Button, Modal, Progress, Select, Spin, Tooltip, Dropdown, Menu } from "antd";
import { cc_graduation_test, EFFECTIVE_WORK_COMMUNICATION } from "../../../../config";
import { displayUtcToUserTimezone, getIntFromString } from "modules/look";
import { dashboard_home_icons } from "modules/poc-dashboard/icons";
import poc_dashboard_routes from "modules/poc-dashboard/routes";
import React, { useEffect } from "react";
import styled from "styled-components";
import Growpagination from "modules/grow-model/components/growPagination";
import InvitationListContainerPOC from "../../containers/poc_report/invitationListContainer"
import CustomReportFilter from "./customFilterReport";
import am_dashboard_routes from "modules/poc-dashboard/account-manager/routes";
import { getOrgID } from "modules/poc-dashboard/containers/organization/organizationOperations";
const PocReprtListView = (props) => {
    const { org_survey_lists,
        selected_survey_response,
        allEmployeeNon360SurveyResponse,
        verticalEmployee360SurveyResponse,
        verticalEmployeeNon360SurveyResponse,
        allEmployee360SurveyResponseDateRange,
        allEmployeeNon360SurveyResponseDateRange,
        table_data_loading,
        navigateRoute,
        sortScore,
        response_page_info,
        survey_list_loading,
        allEmployee360SurveyResponse,
        GetDataForcsvOf360Survey,
        export_loader,
        download_progress,
        setSurveyResponseSet,
        GetDataForcsvOfNon360Survey,
        me,
        selectedResponses,
        setSelectedResponses,
        selectedInviteeResponses,
        setSelectedInviteeResponses,
        handleSendReminders,
        location,
        orgToFetchData,
        setSurveyId,
        all_invitees_list,
        set_all_invitees_list,
        setFilter_obj,
        invitees_list_loading,
        GetSurveyExportURL
    } = props
    const [filter, setFilter] = React.useState()
    const [defult_filter, setDefaultFilter] = React.useState()
    const [invitation_list_detail, SetInvitationListDetail] = React.useState()
    const [select_all_title, set_select_all_title] = React.useState(false);
    const [selectAllClicked, setSelectAllClicked] = React.useState(false);
    let search_timer = React.useRef(null)
    let search_ref = React.useRef({ nameIcontains: null })
    React.useEffect(() => {
        if (org_survey_lists?.length > 0) {
            let default_value = org_survey_lists?.find(item => cc_graduation_test.includes(getIntFromString(item?.id)))
            let selected_survey = JSON.parse(localStorage.getItem('selected_survey_response'))
                ? org_survey_lists?.map(ele => ele?.id)?.includes(JSON.parse(localStorage.getItem('selected_survey_response'))?.id)
                    ? JSON.parse(localStorage.getItem('selected_survey_response'))
                    : null
                : null
            if (selected_survey) {
                setFilter({ id: selected_survey?.id, name: selected_survey?.name, is_360: selected_survey?.is_360, max_score: selected_survey?.max_score })
                setDefaultFilter(selected_survey)
            }
            else {
                if (default_value) {
                    setFilter({ id: default_value?.id, name: default_value?.name, is_360: default_value?.multisourceResponse, max_score: default_value?.max_score })
                    setDefaultFilter({ ...default_value, is_360: default_value?.multisourceResponse })
                }
                else {
                    setFilter({ id: org_survey_lists[0]?.id, name: org_survey_lists[0]?.name, is_360: org_survey_lists[0]?.multisourceResponse, max_score: org_survey_lists[0]?.max_score })
                    setDefaultFilter({ ...org_survey_lists[0], is_360: org_survey_lists[0]?.multisourceResponse })
                    localStorage.setItem('selected_survey_response', JSON.stringify({ ...org_survey_lists[0], is_360: org_survey_lists[0]?.multisourceResponse }))
                }
            }

        }
    }, [org_survey_lists, orgToFetchData])

    React.useEffect(() => {
        if ((filter !== undefined) && (orgToFetchData?.id || getOrgID(props))) {
            setSurveyResponseSet([])
            handleSurveySelect()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, orgToFetchData])


    const seeReport = (item) => {
        localStorage.setItem('selected_survey_response', JSON.stringify(filter))
        navigateRoute(
            Object.values(poc_dashboard_routes).some(routes => location?.pathname.includes(routes))
                ? poc_dashboard_routes
                    ?.poc_user_report.replace(':survey_id', getIntFromString(filter?.id))
                    .replace(':response_id', getIntFromString(item?.response_id))
                : am_dashboard_routes
                    ?.am_user_report.replace(':survey_id', getIntFromString(filter?.id))
                    .replace(':response_id', getIntFromString(item?.response_id))
        )
    }

    const View360InvitationList = (item) => {
        let detail = {
            ...item,
            survey: filter
        }
        SetInvitationListDetail(detail)
    }
    useEffect(() => {
        setSelectedInviteeResponses([]);
        setSelectedResponses([]);
        set_all_invitees_list([]);
        if (filter?.id && filter?.is_360) {
            setFilter_obj(filter)
            setSurveyId(filter?.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter?.id, orgToFetchData])

    const displayResponseStatus = (response_id) => {
        if (response_id) {
            return (
                <div className="s-i-complete-button" style={{ width: "8em" }}>
                    Completed
                </div>
            );
        } else
            return (
                <div className='s-i-pending-button' style={{ width: "8em" }}>
                    Pending
                </div>
            );
    }

    const display360Status = (item) => {
        let is_pending = false
        if (!item?.response_id) {
            is_pending = true
        }
        else if (!item?.total_invitation) {
            is_pending = true
        }
        else if (item?.total_invitation !== item?.completed_invitation) {
            is_pending = true
        }
        if (is_pending) {
            return (
                <div className='s-i-pending-button' style={{ width: "8em" }}>
                    Pending
                </div>
            )
        } else {
            return (
                <div className='s-i-complete-button' style={{ width: "8em" }}>
                    Completed
                </div>
            );
        }

    }

    const exportData = () => {
        if (filter) {
            if (filter?.is_360) {
                GetDataForcsvOf360Survey({ survey: filter?.id, survey_name: filter?.name })
            } else {
                if (EFFECTIVE_WORK_COMMUNICATION.includes(getIntFromString(filter?.id))) {
                    GetSurveyExportURL({ orgId: getIntFromString(orgToFetchData?.id), survey: getIntFromString(filter?.id) })
                } else {
                    GetDataForcsvOfNon360Survey({ survey: filter?.id, survey_name: filter?.name })
                }
            }
        }
    }

    const filterData = [
        { type: 'Name', key: 'Name' },
        { type: 'Email', key: 'Email' },
        { type: 'Vertical', key: 'Vertical' },
        // { type: 'Date', key: 'Date' },
    ]

    const setDefaultData = () => {
        if (filter?.is_360) {
            allEmployee360SurveyResponse({ survey: filter?.id, ...search_ref.current })
        } else {
            allEmployeeNon360SurveyResponse({ survey: filter?.id, ...search_ref.current })
        }
    }

    const fetchResponseData = (search_filters, after = {}) => {
        if (search_filters !== null)
            search_ref.current = search_filters;
        if (!search_ref.current?.nameIcontains?.trim()
            && !search_ref.current?.emailIcontains?.trim()
            && !search_ref.current?.responseDate_Range?.length
            && !search_ref.current?.verticalNameIcontains?.name?.trim()
        ) {
            search_ref.current = { nameIcontains: null, ...after }
            setDefaultData()
        } else if (search_ref.current?.hasOwnProperty('responseDate_Range')) {
            if (filter?.is_360) {
                allEmployee360SurveyResponseDateRange({ survey: filter?.id, ...search_ref.current })
            } else {
                allEmployeeNon360SurveyResponseDateRange({ survey: filter?.id, ...search_ref.current })
            }
        } else if (search_ref.current?.hasOwnProperty('verticalNameIcontains')) {
            const {
                after,
                verticalNameIcontains
            } = search_ref.current
            const new_search_filters = after ? { after: after, ...verticalNameIcontains } : { ...verticalNameIcontains }
            if (filter?.is_360) {
                verticalEmployee360SurveyResponse({ survey: filter?.id, ...new_search_filters })
            } else {
                verticalEmployeeNon360SurveyResponse({ survey: filter?.id, ...new_search_filters })
            }
        } else {
            setDefaultData()
        }
    }

    const handleSurveySelect = () => {
        fetchResponseData(null)
    }

    const onPagination = () => {
        if (filter) {
            search_ref.current = { ...search_ref.current, after: response_page_info?.after }
            fetchResponseData(null, { after: response_page_info?.after })
        }
    }

    const SubmitFilter = (search_filters) => {
        if (search_timer.current) {
            clearTimeout(search_timer?.current)
        }
        search_timer.current = setTimeout(() => {
            fetchResponseData(search_filters)
        }, 500);
    }

    const listDropDown = (value) => {
        return (
            <Menu style={{ width: "100%" }}>
                <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: "center", gap: '1em', padding: "1em 2em" }}>
                    <h4 className='org-table-body-label' style={{ fontWeight: "600", fontSize: "1.5em" }}>{value?.title}</h4>
                    {value?.item?.map((vertical, index) => (
                        <h4 key={index} className='org-table-body-label' style={{ fontWeight: "500", fontSize: "1em" }}>{vertical}</h4>
                    ))}
                </div>
            </Menu>
        );
    }

    const getScore = (id) => {
        let selected_survey = org_survey_lists?.find(i => i?.id === id)
        return (
            <h4 className="org-table-header-label" style={{ color: "#000" }}>Max Score : {selected_survey?.max_score || 0}</h4>
        )
    }


    const toggleResponseSelection = (responseId, responseSource) => {
        const isSelected = selectedResponses.includes(responseId);

        // Toggle responseId
        setSelectedResponses(prev =>
            isSelected ? prev.filter(id => id !== responseId) : [...prev, responseId]
        );

        // If it's 360, toggle invitees tied to this responseId
        if (filter?.is_360) {
            const matchingInvitees = all_invitees_list?.filter(invitee =>
                invitee?.responseSourceFor?.id === responseSource &&
                invitee?.valid
            ) || [];
            const matchingIds = matchingInvitees.map(inv => inv.id);
            setSelectedInviteeResponses(prev => {
                // eslint-disable-next-line no-unused-vars
                const prevSet = new Set(prev);

                if (isSelected) {
                    // We are deselecting → remove all matching invitees
                    return prev.filter(id => !matchingIds.includes(id));
                } else {
                    // We are selecting → add matching invitees
                    return [...new Set([...prev, ...matchingIds])];
                }
            });
        }
    };
    useEffect(() => {
        // Early return if data is not available
        if (!selected_survey_response || !all_invitees_list) return;
        const selectedResponsesCount = selectedResponses.length;
        const selectedInviteeResponsesCount = selectedInviteeResponses.length;

        // Filter out survey responses that have a response_id
        const surveyResponsesWithId = selected_survey_response
            .filter(item => item.response_id != null);

        // Filter out survey responses that don't have a response_id
        const surveyResponsesWithoutId = selected_survey_response
            .filter(item => item.response_id == null);

        // Calculate the invitees related to the pending responses


        // Check if the combined selected responses and selected invitee responses
        // match the pending responses and pending invitees
        let isMatch;
        if (filter?.is_360) {

            isMatch =
                selectedResponsesCount + selectedInviteeResponsesCount - surveyResponsesWithId.length
                === surveyResponsesWithoutId.length + selectedInviteeResponses.length

        } else {
            isMatch =
                selectedResponsesCount - surveyResponsesWithId.length
                === surveyResponsesWithoutId.length;
        }

        // Set the condition for "Select All" or "Deselect All"
        set_select_all_title(isMatch);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectAllClicked,
        filter,
        orgToFetchData,
        all_invitees_list,
        selected_survey_response,
        selectedResponses,
        selectedInviteeResponses,

    ]);


    const handleSelectAllPending = () => {
        setSelectAllClicked(!selectAllClicked)
        const pendingResponses = selected_survey_response
            ?.filter(item => item.user_id)
            ?.map(item => item.user_id) || [];

        const pendingInvitees = all_invitees_list
            ?.filter(item => pendingResponses.includes(item?.createdBy?.id)
            )
            ?.map(item => item.id) || [];


        const responseSet = new Set(selectedResponses);
        const inviteeSet = new Set(selectedInviteeResponses);

        const allPendingResponsesSelected = pendingResponses.every(id => responseSet.has(id));
        const allPendingInviteesSelected = pendingInvitees.every(id => inviteeSet.has(id));

        if (allPendingResponsesSelected && allPendingInviteesSelected) {
            // Deselect all if all pending are selected
            setSelectedResponses(prev => prev.filter(id => !pendingResponses.includes(id)));
            setSelectedInviteeResponses(prev => prev.filter(id => !pendingInvitees.includes(id)));
        } else {
            // Add all missing pending items
            setSelectedResponses(prev => [...new Set([...prev, ...pendingResponses])]);
            setSelectedInviteeResponses(prev => [...new Set([...prev, ...pendingInvitees])]);
        }
        // set_select_all_title(!allPendingSelected);

    };

    // const toggleResponseInviteeSelection = (responseId) => {
    //     setSelectedInviteeResponses(prev =>
    //         prev.includes(responseId)
    //             ? prev.filter(id => id !== responseId)
    //             : [...prev, responseId]
    //     );
    // };

    const sendSelectedReminders = () => {
        const pendingItems = selected_survey_response?.filter(
            item => selectedResponses.includes(item.user_id) && !item?.response_id
        );
        const pendingInviteeItems = all_invitees_list?.filter(
            item => selectedInviteeResponses.includes(item.id) && item?.valid
        );


        const reminderData = pendingItems?.map(item => ({
            id: Number(getIntFromString(filter?.id)),
            usr: Number(getIntFromString(item.user_id)), // Using user_id here
            tlink: String(item?.link || "")
        }));
        const reminderInviteesData = pendingInviteeItems?.map(item => ({
            id: Number(getIntFromString(filter?.id)),
            usr: Number(getIntFromString(item.user.id)), // Using user_id here
            tlink: String(item?.link || "")
        }));
        if (reminderData.length > 0 || reminderInviteesData.length > 0) {
            handleSendReminders(reminderData);
            handleSendReminders(reminderInviteesData);
        }
    };
    return (
        <div>

            <Spin spinning={survey_list_loading || table_data_loading || invitees_list_loading}>
                {
                    org_survey_lists?.length ?
                        <div className="poc-org-root poc-survey-report-main-container" style={{ height: "100%", maxHeight: "100%" }}>
                            <div style={{ padding: "0.5em", display: "flex", justifyContent: "center" }}>
                                <h4 className="poc-dashboard-card-title" style={{ textAlign: "center" }}>Survey Report</h4>
                            </div>

                            <div className="row-layout-wrap" style={{ margin: "0.5em 0px", padding: "0em 2em" }} >

                                <div className="poc-survey-selector-report">
                                    <p className="poc-dashboard-card-title" style={{ fontSize: '.85em', fontWeight: "500" }}>Choose survey to see the reports</p>
                                    {defult_filter
                                        && <CustomSelectSurvey
                                            dropdownClassName="content-dropdown"
                                            placeholder="Select Survey"
                                            onChange={
                                                (e, item) => {
                                                    setFilter({ id: item?.key, name: item?.value, is_360: item?.label, max_score: item?.max_score })
                                                    localStorage.setItem('selected_survey_response', JSON.stringify({ id: item?.key, name: item?.value, is_360: item?.label, max_score: item?.max_score }))
                                                }
                                            }
                                            defaultValue={defult_filter?.name}
                                            value={filter?.name}
                                        >
                                            {org_survey_lists?.map(item => (
                                                <Select.Option className='dashobard-performance-table-heading' style={{ color: '#A3A3A3', fontFamily: "Poppins", fontWeight: 500 }} key={item?.id} value={item?.name} label={item?.multisourceResponse}>{item?.name}</Select.Option>
                                            ))}
                                        </CustomSelectSurvey>
                                    }
                                </div>

                                <div className="poc-report-action-detail-section">
                                    <CustomReportFilter
                                        me={me}
                                        onfilterChange={(e) => SubmitFilter(e)}
                                        filterData={filterData}
                                        {...props}
                                    />

                                    {!table_data_loading && selected_survey_response?.length ?
                                        <div className="poc-report-export-score-scetion">

                                            {!export_loader ?
                                                <Button className="poc-report-export-btn" onClick={() => exportData()}  ><img src={dashboard_home_icons?.export_icon} alt="export_icon" style={{ height: "1.25em", marginRight: "1em" }} /> Export</Button> :
                                                <div className='org-export-btn-parent'>
                                                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: 'center', gap: ".5em" }}>
                                                        <Spin spinning={true} tip='Exporting...'></Spin>
                                                        <Progress type="circle" percent={download_progress} strokeColor="#4CCB1F" strokeWidth={10} />
                                                    </div>
                                                </div>
                                            }
                                            {cc_graduation_test.includes(getIntFromString(filter?.id)) && (getScore(filter?.id))}
                                        </div>
                                        : <div></div>}
                                </div>
                            </div>
                            <div className='org-table-container poc_table_scroll poc-report-table-height' style={{ width: '100%', padding: "0em 2em", marginTop: "0em" }}>
                                {(selectedResponses.length > 0 || selectedInviteeResponses.length > 0) && (
                                    <div className="reminder-selection-header" style={{
                                        padding: '1em 2em',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        backgroundColor: '#f9fafb',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '8px',
                                        marginBottom: '1rem'
                                    }}>
                                        <div>
                                            <button
                                                onClick={handleSelectAllPending}
                                                style={{
                                                    backgroundColor: '#4ccb1f',
                                                    color: 'white',
                                                    padding: '0.5em 1em',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    marginRight: '1em'
                                                }}
                                            >
                                                {select_all_title
                                                    ? "Deselect All"
                                                    : "Select All Pending"}
                                            </button>

                                            <span>{selectedResponses.length + selectedInviteeResponses.length - selected_survey_response.filter(item => item.response_id && selectedResponses.some(resp => resp === item.user_id)).length} selected</span>
                                        </div>

                                        <button
                                            onClick={sendSelectedReminders}
                                            disabled={selectedResponses.length === 0 && selectedInviteeResponses.length === 0}
                                            style={{
                                                backgroundColor: '#4ccb1f',
                                                color: 'white',
                                                padding: '0.5em 1em',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: selectedResponses.length === 0 && selectedInviteeResponses.length === 0 ? 'not-allowed' : 'pointer',
                                                opacity: selectedResponses.length === 0 && selectedInviteeResponses.length === 0 ? 0.6 : 1
                                            }}
                                        >
                                            Send Reminders
                                        </button>
                                    </div>
                                )}


                                {
                                    !filter?.is_360 ?
                                        <table className='org-table'>
                                            <thead>
                                                <tr className='org-row-header'>
                                                    <th className='org-table-row-padding-left org-left-radious' >
                                                        <h4 className='org-table-header-label'>Name</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Email</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Vertical</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Response Date</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Status</h4>
                                                    </th>
                                                    {cc_graduation_test.includes(getIntFromString(filter?.id)) &&
                                                        <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "center", alignItems: 'center', gap: '0.25em' }}>
                                                                <h4 className='org-table-header-label' style={{ margin: "0em" }}>Score</h4>
                                                                <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: 'center', gap: '0.25em' }}>
                                                                    <svg width="20" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: ".55em", cursor: "pointer" }} onClick={() => sortScore("ascending")}>
                                                                        <path d="M4.7 25L20 9.54791L35.3 25L40 20.2429L20 0L0 20.2429L4.7 25Z" fill="#fff" fill-opacity="1" />
                                                                    </svg>
                                                                    <svg width="20" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: ".55em", cursor: "pointer" }} onClick={() => sortScore("descending")}>
                                                                        <path d="M4.7 0L20 15.4521L35.3 0L40 4.75709L20 25L0 4.75709L4.7 0Z" fill="#fff" fill-opacity="1" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </th>

                                                    }
                                                    <th className='org-table-header-label org-table-row-padding-rigth org-content-center org-table-header-label org-right-radious' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Action</h4>

                                                    </th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    selected_survey_response?.map(item => (
                                                        <tr className='org-row-body'>
                                                            <td className='org-left-radious org-table-row-padding-left table-border-left' style={{ borderRight: "none" }}>
                                                                <div className="checkbox-td">

                                                                    <input
                                                                        type="checkbox"
                                                                        checked={!item?.response_id ? selectedResponses.includes(item.user_id) : undefined}
                                                                        onChange={() => toggleResponseSelection(item.user_id)}
                                                                        disabled={!!item.response_id}
                                                                        style={{ transform: "scale(1.5)", marginLeft: "5px" }}
                                                                    />
                                                                    <h4 className='org-table-body-label' style={{ fontWeight: '500' }}><span className="text-transform-capitalize">{item?.firstName}</span> <span className="text-transform-capitalize">{item?.lastName}</span></h4>
                                                                </div>
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <h4 className='org-table-body-label' style={{ fontWeight: '500' }}>{item?.email}</h4>
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                {item?.vertical?.length > 0
                                                                    ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", gap: ".25em", width: '100%', opacity: '1' }}>
                                                                        <h4 className='org-table-body-label org-vertical-type' style={{ background: "rgba(38, 196, 165, 0.1)", color: "rgba(16, 165, 136, 1)", padding: ".5em 1em" }}>{item?.vertical[0]}</h4>
                                                                        {item?.vertical?.length > 1 &&
                                                                            <Dropdown overlay={listDropDown({ item: item?.vertical, title: "Verticals" })} placement="topCenter"
                                                                                overlayStyle={{ width: 'fit-content' }} >
                                                                                <h4 className='org-table-body-label org-vertical-type' style={{ background: "rgba(38, 196, 165, 0.1)", color: "rgba(16, 165, 136, 1)", padding: '.5em .5em', cursor: "pointer" }}>{item?.vertical?.length - 1}+</h4>
                                                                            </Dropdown>}
                                                                    </div>
                                                                    : <h4 className='org-table-body-label' style={{ opacity: (item?.verified && item?.active_status === "Inactive") ? '.5' : '1' }}>-</h4>}
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <h4 className='org-table-body-label' style={{ fontWeight: '500' }}>{item?.responseDate ? displayUtcToUserTimezone(item?.responseDate, 'MMM DD YYYY, hh:mm') : ""}</h4>
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <div className="poc-table-action-td">
                                                                    {displayResponseStatus(item?.response_id)}
                                                                </div>
                                                            </td>
                                                            {cc_graduation_test.includes(getIntFromString(filter?.id)) && <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <h4 className='org-table-body-label' style={{ fontWeight: '500' }}>{item?.response_id ? item?.totalScore : ""}</h4>
                                                            </td>}
                                                            <td className='org-table-row-padding-rigth org-content-center org-right-radious table-border-right' style={{ borderLeft: "none", marginLeft: "1em" }}>
                                                                {
                                                                    item?.response_id && (
                                                                        <Tooltip title={"View Report"}>
                                                                            <img src={dashboard_home_icons?.report_icon} alt="report_icon" style={{ cursor: "pointer" }} onClick={() => seeReport(item)} />
                                                                        </Tooltip>
                                                                    )
                                                                }





                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table> :
                                        <table className='org-table'>
                                            <thead>
                                                <tr className='org-row-header'>
                                                    <th className='org-table-row-padding-left org-left-radious' >
                                                        <h4 className='org-table-header-label'>Name</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Email</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Vertical</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Response Date</h4>
                                                    </th>
                                                    <th className='org-table-header-label' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Status</h4>
                                                    </th>

                                                    <th className='org-table-header-label org-table-row-padding-rigth org-content-center org-table-header-label org-right-radious' style={{ textAlign: "center" }}>
                                                        <h4 className='org-table-header-label'>Action</h4>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    selected_survey_response?.map((item, index) => (
                                                        <tr className='org-row-body' key={index}>
                                                            <td className='org-left-radious org-table-row-padding-left table-border-left' style={{ borderRight: "none" }}>
                                                                <div className="checkbox-td">

                                                                    <input
                                                                        type="checkbox"
                                                                        checked={
                                                                            (item?.response_id &&
                                                                                item?.completed_invitation === item?.total_invitation)
                                                                                ? false
                                                                                : (
                                                                                    (item?.response_id && item?.completed_invitation) ||
                                                                                    (item?.response_id && item?.total_invitation) ||
                                                                                    !item?.response_id
                                                                                )
                                                                                    ? selectedResponses.includes(item.user_id)
                                                                                    : undefined
                                                                        }
                                                                        onChange={() => toggleResponseSelection(item.user_id, item?.responseSource)}
                                                                        disabled={
                                                                            !!item.response_id &&
                                                                            item?.total_invitation === item?.completed_invitation
                                                                        }
                                                                        style={{ transform: "scale(1.5)", marginLeft: "5px" }}
                                                                    />


                                                                    <h4 className='org-table-body-label' style={{ fontWeight: '500' }}><span className="text-transform-capitalize">{item?.firstName}</span> <span className="text-transform-capitalize">{item?.lastName}</span></h4>
                                                                </div>
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <h4 className='org-table-body-label' style={{ fontWeight: '500' }}>{item?.email}</h4>
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                {item?.vertical?.length > 0
                                                                    ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", gap: ".25em", width: '100%', opacity: '1' }}>
                                                                        <h4 className='org-table-body-label org-vertical-type' style={{ background: "rgba(38, 196, 165, 0.1)", color: "rgba(16, 165, 136, 1)", padding: ".5em 1em" }}>{item?.vertical[0]}</h4>
                                                                        {item?.vertical?.length > 1 &&
                                                                            <Dropdown overlay={listDropDown({ item: item?.vertical, title: "Verticals" })} placement="topCenter"
                                                                                overlayStyle={{ width: 'fit-content' }} >
                                                                                <h4 className='org-table-body-label org-vertical-type' style={{ background: "rgba(38, 196, 165, 0.1)", color: "rgba(16, 165, 136, 1)", padding: '.5em .5em', cursor: "pointer" }}>{item?.vertical?.length - 1}+</h4>
                                                                            </Dropdown>}
                                                                    </div>
                                                                    : <h4 className='org-table-body-label' style={{ opacity: (item?.verified && item?.active_status === "Inactive") ? '.5' : '1' }}>-</h4>}
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <h4 className='org-table-body-label' style={{ fontWeight: '500' }}>{item?.responseDate ? displayUtcToUserTimezone(item?.responseDate, 'MMM DD YYYY, hh:mm') : ""}</h4>
                                                            </td>
                                                            <td className='table-border-up-down' style={{ textAlign: "center", borderRight: "none", borderLeft: "none" }}>
                                                                <div className="poc-table-action-td">
                                                                    {display360Status(item)}
                                                                </div>
                                                            </td>
                                                            <td className='org-table-row-padding-rigth org-content-center org-right-radious table-border-right' style={{ borderLeft: "none", marginLeft: "1em" }}>

                                                                <div className="poc-table-action-td">
                                                                    {
                                                                        (item?.response_id && item?.completed_invitation) ?
                                                                            <Tooltip title={"View 360 Report"}>
                                                                                <Button className="border-action-btn" onClick={() => seeReport(item)}>
                                                                                    <img src={dashboard_home_icons?.report_360} alt="360_report_icon" />
                                                                                </Button>
                                                                            </Tooltip>
                                                                            : <Button className="report-action-btn-disabled"  >
                                                                                <img src={dashboard_home_icons?.report_360} alt="360_report_icon" />
                                                                            </Button>
                                                                    }
                                                                    {
                                                                        (item?.response_id && item?.total_invitation) ?
                                                                            <Tooltip title={"View 360 detail"}>
                                                                                <Button className="border-action-btn" onClick={() => { View360InvitationList(item) }}>
                                                                                    <img src={dashboard_home_icons?.invite_360} alt="360_invite" />
                                                                                </Button>
                                                                            </Tooltip> : <Button className="report-action-btn-disabled" >
                                                                                <img src={dashboard_home_icons?.invite_360} alt="360_invite" />
                                                                            </Button>

                                                                    }


                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                }


                                {
                                    (!selected_survey_response?.length && !table_data_loading) ?
                                        <div className='rd-nodata' style={{ minHeight: "10em" }}>
                                            <h4 className='rd-nodata-label'>No data found</h4>
                                        </div> : ''
                                }
                                {(response_page_info?.hasNextPage && response_page_info?.after && !table_data_loading) && <div align='center'>
                                    <Growpagination on_pagination={() => onPagination()} />
                                </div>}
                            </div>

                        </div> : ""
                }

            </Spin>
            {(!survey_list_loading && !org_survey_lists?.length) ? <div className='rd-nodata' style={{ minHeight: "70vh" }}>
                <h4 className='rd-nodata-label'>No Survey found</h4>
            </div> : ""}

            <Modal
                visible={invitation_list_detail}
                destroyOnClose={true}
                footer={false}
                closable={false}
                centered={true}
                width="1100px"
                style={{ maxWidth: "90%" }}
            >
                <InvitationListContainerPOC
                    invitation_list_detail={invitation_list_detail}
                    onClose={() => SetInvitationListDetail(null)}
                    selectedInviteeResponses={selectedInviteeResponses}
                    {...props}
                />

            </Modal>
        </div>
    )
}


export default PocReprtListView;
const CustomSelectSurvey = styled(Select)`
.ant-select-selector{
    border: 1px solid #AABAC6 !impoortant;
    color:  #000;
    font-weight: 500;
    font-family: Poppins;
    font-size: 1em;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.01em;
    text-align: left;
    border-radius:.5em !important;
    width:20em !important;
    height: 40px !important;
    padding-top: 4px !important;
}
`;